import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAnchor } from "@fortawesome/free-solid-svg-icons"

export const Anchor = (props) => {
  return <FontAwesomeIcon faIcon={faAnchor} {...props} />
}
